module.exports = __webpack_public_path__ + "img/cyborg.53c6d31e.png";